<template>
  <div
    class="viluu-landing viluu-csae"
    :class="{ 'is-leaving': isLeaving, 'from-bfcache': fromBfcache }"
  >
    <the-nav variant="subpage" />

    <div class="csae-wrap">
      <div class="container">
        <div class="pill">Kinderschutz</div>

        <h1>Child Safety <em>Standards</em><span class="title-dot">.</span></h1>

        <p class="lede">
          We2Gether GmbH, Betreiberin von Viluu, verfolgt eine Null-Toleranz-Politik gegenüber
          jeglicher Form von Kindesmissbrauch und sexueller Ausbeutung von Kindern (CSAE). Diese
          Seite legt unsere Standards, unsere Meldewege und unseren Ansprechpartner für
          Kinderschutzthemen offen.
        </p>

        <div class="card">
          <div class="card-title">Ansprechpartner für Kinderschutz (Child Safety Point of Contact)</div>
          <p style="margin-bottom: 4px">Viluu Kundensupport</p>
          <p style="margin-bottom: 0">E-Mail: <a href="mailto:csae@viluu.de">csae@viluu.de</a></p>
          <p style="margin-top: 10px; margin-bottom: 0; font-size: 15px">
            Meldungen an diese Adresse werden an dafür qualifiziertes Personal weitergeleitet, das zu
            Enforcement- und Review-Prozessen Auskunft geben und erforderliche Maßnahmen einleiten
            kann.
          </p>
          <p style="margin-top: 10px; margin-bottom: 0; font-size: 15px">
            <strong>Reaktionszeit:</strong> Wir bearbeiten eingehende Benachrichtigungen und
            Eskalationen in der Regel innerhalb von 24 Stunden, bei dringenden Fällen schneller.
          </p>
        </div>

        <h2>Unsere Position zu Kindesmissbrauch und -ausbeutung</h2>
        <p>
          Viluu richtet sich ausschließlich an volljährige Nutzer:innen. Inhalte, Verhaltensweisen
          oder Kontaktversuche, die Minderjährige sexuell ausbeuten, gefährden, anbahnen
          ("Grooming") oder in irgendeiner Form schädigen, sind auf Viluu strikt untersagt.
        </p>
        <p>Dies umfasst insbesondere:</p>
        <ul>
          <li>
            das Erstellen, Hochladen, Versenden, Speichern oder Verbreiten von
            Kindesmissbrauchsdarstellungen ("Child Sexual Abuse Material", CSAM) in jeglicher Form
            (Bild, Video, Text oder computergenerierte Inhalte);
          </li>
          <li>die Kontaktaufnahme zu Minderjährigen mit dem Ziel der sexuellen Ausbeutung ("Grooming");</li>
          <li>sexuelle Erpressung ("Sextortion") oder Bedrohung von Minderjährigen;</li>
          <li>jede Form von Menschenhandel oder Ausbeutung von Kindern zu sexuellen Zwecken;</li>
          <li>
            die Nutzung von Viluu zur Anbahnung, Organisation oder Förderung der oben genannten
            Handlungen.
          </li>
        </ul>

        <h2>Begriffsbestimmungen</h2>
        <p>Im Sinne dieser Standards umfasst CSAE (Child Sexual Abuse and Exploitation) insbesondere:</p>
        <ul>
          <li>
            <strong>CSAM (Child Sexual Abuse Material):</strong> Jede visuelle Darstellung (Foto,
            Video, Zeichnung, computergenerierte Darstellung) eines Minderjährigen bei sexuellen
            Handlungen oder mit Fokus auf Körperteilen zu sexuellen Zwecken.
          </li>
          <li>
            <strong>Grooming:</strong> Anbahnung oder Aufbau einer emotionalen Bindung zu einem
            Minderjährigen mit dem Ziel der sexuellen Ausbeutung oder zur Vorbereitung von Missbrauch.
          </li>
          <li>
            <strong>Sextortion:</strong> Drohung, intime Aufnahmen eines Minderjährigen zu verbreiten
            oder offenzulegen, um weitere sexuelle Handlungen oder sonstige Vorteile zu erzwingen.
          </li>
          <li>
            <strong>Sexualisierung von Minderjährigen:</strong> Darstellung oder Förderung von
            Minderjährigen in sexueller Weise oder in sexualisierten Kontexten.
          </li>
          <li>
            <strong>Menschenhandel und Ausbeutung:</strong> Angebot, Nachfrage oder Ermöglichung der
            Ausbeutung von Minderjährigen zu sexuellen Zwecken.
          </li>
        </ul>
        <p>
          Jeder Inhalt, jedes Verhalten, jede Nachricht oder jedes Konto, das gegen diese
          Definitionen verstößt, unterliegt Maßnahmen gemäß dieser Standards.
        </p>

        <h2>Maßnahmen und Durchsetzung</h2>
        <p>Verstöße gegen diese Standards führen zu:</p>
        <ul>
          <li>der sofortigen und dauerhaften Sperrung des betreffenden Nutzerkontos;</li>
          <li>der unverzüglichen Entfernung der betreffenden Inhalte, sobald wir Kenntnis davon erhalten;</li>
          <li>
            der Meldung an die zuständigen Strafverfolgungsbehörden bzw. an das National Center for
            Missing &amp; Exploited Children (NCMEC) oder die jeweils zuständige regionale Behörde,
            soweit gesetzlich vorgeschrieben oder geboten;
          </li>
          <li>
            der Sicherung relevanter Daten im Rahmen der gesetzlichen Aufbewahrungspflichten zur
            Unterstützung von Ermittlungen.
          </li>
        </ul>
        <p>
          We2Gether GmbH arbeitet im Einklang mit den geltenden Kinderschutzgesetzen und
          -vorschriften sowie mit international anerkannten Standards, unter anderem den Empfehlungen
          der Tech Coalition zur Bekämpfung von Online-CSAE.
        </p>

        <h2>Melden von Verstößen</h2>
        <p>
          Nutzer:innen können verdächtige Inhalte, Profile oder Verhaltensweisen jederzeit direkt in
          der App über die Melde- bzw. Feedback-Funktion anzeigen. Jede Meldung wird von unserem
          Team geprüft und entsprechend dieser Standards bearbeitet.
        </p>
        <p>
          Zusätzlich kann Kontakt aufgenommen werden über:
          <a href="mailto:csae@viluu.de">csae@viluu.de</a>
        </p>
        <p>
          Gemeldete Inhalte werden von unserem Team geprüft und im Verdachtsfall priorisiert und
          eskaliert. Bestätigte Verstöße führen zur Entfernung der Inhalte, zur Sperrung des
          betroffenen Kontos sowie, soweit gesetzlich vorgeschrieben, zur Meldung an die zuständigen
          Behörden.
        </p>

        <h2>Selbstzertifizierung gegenüber Google Play</h2>
        <p>Im Rahmen unserer Erklärung in der Google Play Console bestätigen wir, dass wir:</p>
        <ul>
          <li>diese öffentlich zugänglichen CSAE-Standards pflegen und in der Play Console verlinken;</li>
          <li>einen In-App-Mechanismus für Nutzer-Feedback und CSAE-Meldungen bereitstellen;</li>
          <li>
            bei tatsächlicher Kenntnis von CSAE/CSAM angemessen handeln, einschließlich Entfernung
            von Inhalten und Sperrung von Konten;
          </li>
          <li>
            geltende Kinderschutzgesetze einhalten und Verstöße den zuständigen Behörden melden,
            soweit vorgeschrieben;
          </li>
          <li>
            einen Ansprechpartner benennen, der CSAE-Benachrichtigungen von Google oder Behörden
            bearbeiten kann.
          </li>
        </ul>

        <div class="meta">
          Letzte Aktualisierung: 26.06.2026<br />
          Änderungsprotokoll: 26.06.2026 – Erstveröffentlichung der Child Safety Standards für Viluu.
        </div>
      </div>
    </div>

    <the-footer variant="legal" />
    <signup-modal />
    <cookie-banner />
  </div>
</template>

<script>
import { landingChromeMixin } from '../landingChrome';
import CookieBanner from '../../../../components/LandingV2/CookieBanner.vue';
import TheNav from '../../../../components/LandingV2/sections/TheNav.vue';
import TheFooter from '../../../../components/LandingV2/sections/TheFooter.vue';
import SignupModal from '../../../../components/LandingV2/signup/SignupModal.vue';

export default {
  name: 'CsaePage',
  mixins: [landingChromeMixin],
  components: { CookieBanner, TheNav, TheFooter, SignupModal },
};
</script>

<style scoped lang="scss">
/* Standalone Child Safety design (from the supplied CSAE.html), wrapped with
   the shared viluu nav + footer. Colour tokens are namespaced (--csae-*) so
   they don't cascade into the nav/footer, which keep the site palette. */
.viluu-csae {
  --csae-bg-cream: #fdf6f0;
  --csae-ink: #1a0c14;
  --csae-body-text: #6b4955;
  --csae-pink: #d44e85;
  --csae-orange: #f0944a;
  --csae-pill-bg: #f7e1ea;
  --csae-pill-text: #c2386f;
  --csae-card-border: #f3e3ea;

  position: relative;
  min-height: 100vh;
  background:
    radial-gradient(circle at 15% 0%, rgba(240, 148, 74, 0.2), transparent 45%),
    radial-gradient(circle at 85% 10%, rgba(212, 78, 133, 0.18), transparent 50%),
    var(--csae-bg-cream);
}

.csae-wrap {
  position: relative;
  overflow: hidden;
  padding: 56px 24px 80px;
}

.container {
  max-width: 760px;
  margin: 0 auto;
  font-family: 'Inter Tight', system-ui, sans-serif;
  color: var(--csae-body-text);
  line-height: 1.6;
}

.container *,
.container *::before,
.container *::after {
  box-sizing: border-box;
}

.pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--csae-pill-bg);
  color: var(--csae-pill-text);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 6px 14px;
  border-radius: 999px;
  margin-bottom: 20px;
}

.pill::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--csae-pill-text);
  display: inline-block;
}

.container h1 {
  font-family: 'Bricolage Grotesque', system-ui, sans-serif;
  font-weight: 800;
  font-size: 48px;
  line-height: 1.08;
  color: var(--csae-ink);
  margin: 0 0 20px;
}

.container h1 em {
  font-style: italic;
  font-weight: 800;
  background: linear-gradient(90deg, var(--csae-pink), var(--csae-orange));
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  /* background-clip: text only paints inside the line box; the italic slant of
     the last letter overhangs it and gets clipped. Right padding widens the box
     and box-decoration-break: clone keeps it intact across wrapped lines. */
  padding-right: 0.12em;
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
}

.container h1 .title-dot {
  /* Pull the period back over the em's right padding so it stays tight against
     the gradient word instead of floating after a gap. */
  margin-left: -0.1em;
  color: var(--csae-ink);
}

.lede {
  font-size: 18px;
  color: var(--csae-body-text);
  max-width: 640px;
  margin: 0 0 36px;
}

.card {
  background: linear-gradient(135deg, #ffffff, #fdeef2);
  border: 1px solid var(--csae-card-border);
  border-radius: 20px;
  padding: 24px 28px;
  margin: 28px 0 44px;
  box-shadow: 0 4px 24px rgba(212, 78, 133, 0.08);
}

.card-title {
  font-weight: 700;
  color: var(--csae-ink);
  margin-bottom: 8px;
  font-size: 16px;
}

.card a {
  color: var(--csae-pink);
  text-decoration: none;
  font-weight: 600;
}

.card a:hover {
  text-decoration: underline;
}

.container h2 {
  font-family: 'Bricolage Grotesque', system-ui, sans-serif;
  font-weight: 700;
  font-size: 28px;
  color: var(--csae-ink);
  margin: 44px 0 14px;
}

.container p {
  font-size: 17px;
  color: var(--csae-body-text);
  margin: 0 0 16px;
}

.container ul {
  margin: 0 0 20px;
  padding-left: 22px;
}

.container li {
  font-size: 17px;
  color: var(--csae-body-text);
  margin-bottom: 10px;
}

.container strong {
  color: var(--csae-ink);
}

.container a {
  color: var(--csae-pink);
}

.meta {
  font-size: 14px;
  color: #a98a96;
  margin-top: 48px;
  border-top: 1px solid var(--csae-card-border);
  padding-top: 20px;
}

@media (max-width: 640px) {
  .csae-wrap {
    padding: 36px 18px 56px;
  }
  .container h1 {
    font-size: 34px;
    line-height: 1.12;
  }
  .pill {
    font-size: 12px;
    padding: 5px 12px;
    margin-bottom: 16px;
  }
  .lede {
    font-size: 16px;
    margin-bottom: 28px;
  }
  .card {
    padding: 18px 20px;
    border-radius: 16px;
    margin: 20px 0 32px;
  }
  .card-title {
    font-size: 15px;
  }
  .container h2 {
    font-size: 22px;
    margin: 32px 0 12px;
  }
  .container p,
  .container li {
    font-size: 15.5px;
  }
  .container ul {
    padding-left: 18px;
  }
  .meta {
    font-size: 13px;
    margin-top: 36px;
  }
}

@media (max-width: 380px) {
  .container h1 {
    font-size: 28px;
  }
  .card {
    padding: 16px;
  }
}
</style>
